import {ProductsResponseModel} from '../models/products-response.model';
import {HttpServiceBase} from '../../../core/services/http-service-base';

export abstract class IProductService extends HttpServiceBase{

    // https://minntgmbh.atlassian.net/wiki/spaces/BROT/pages/3140190210/BROTHER+GET+Product+List+for+Project+v1
    public abstract getProjectProducts( projectId?: number ): Promise<ProductsResponseModel>;
}

